import * as React from 'react';
import InfogramEmbedNPM from '@rotaryintl/app-infogram-embed';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const InfogramEmbed = (props) => {
  return (
    <>
      <style>
        {`
          @media (max-width: 480px) {
            .rwc-infogram-embed .rwc-infogram-embed__iframe {
              height: 60vh !important;
              min-height: 0 !important;
            }
          }

          @media (min-width: 768px) and (max-width: 1199px) {
            .rwc-infogram-embed .rwc-infogram-embed__iframe {
              height: 75vh !important;
              min-height: 0 !important;
            }
          }

          .rwc-rich-text {
            margin-top: 20px !important;
          }
        `}
      </style>

      <InfogramEmbedNPM title={props.fields?.Title?.value} infogramID={props.fields?.InfogramID?.value} />
    </>
  );
};

export default withSitecoreContext()(InfogramEmbed); 